





/**
 * Base class for all the Search services.
 *
 * @private
 * @class Search
 * @module Services
 * @uses Chain
 * @uses ProtocolMixin
 * @uses KeyMixin
 * @uses LimitMixin
 * @uses LanguageMixin
 * @uses UnwrapMixin
 *
 * @constructor
 * @param {Object}   [options] Options to be passed to the search call,
 *     or Array of such options objects to perform batch request.
 * @param {String}   [options.key] An API Key issued from <a href="https://developer.tomtom.com">Developer Portal</a>
 * @param {"http"|"https"} [options.protocol="https"] Protocol's type
 * @param {Boolean}  [options.unwrapBbox=false] Changes the bounding box coordinates allowing longitudes that
 *  exceeds 180 degrees when is necessary. {{#crossLink "Search/unwrapBbox:method"}}More{{/crossLink}}
 * @param {Number}   [options.limit=10] Maximum number of responses that will be returned
 * @param {String}   [options.language=null] Language to use in the response.
 *  The list with all the available codes can be found
 *  <a href="https://developer.tomtom.com/search-api/search-api-documentation/supported-languages">here</a>.
 * @param {Function} [options.callback] Callback function to use in case of success
 * @param {Function} [options.fail=default] Callback function to use in case of failure
 */
/* jshint nomen:false */
define(['rest/search', 'model/search/search', '../chain', '../validators', '../converters', '../worldEdge',
    '../utils', 'model/search/batchSearch', 'common/searchTypes', './searchParameters'],
function(restSearch, model, chain, validators, converters, worldEdge, utils, batchModel, searchTypes, searchParams) {
    'use strict';

    var TYPES = {
            search: searchTypes.search,
            poi: searchTypes.poi,
            category: searchTypes.category,
            geometry: searchTypes.geometry,
            nearby: searchTypes.nearby,
            lowBandwidth: searchTypes.lowBandwidth
        }, fields = searchParams.create();

    var search = restSearch();

    function addBoundingBoxParameters(data, boundingBox) {
        data.topLeft = [boundingBox.maxLat, boundingBox.minLon];
        data.btmRight = [boundingBox.minLat, boundingBox.maxLon];
        return data;
    }

    function callbackBestResult(bestResult, callback) {
        return function(response) {
            callback(bestResult ? response[0] : response);
        };
    }

    function Search(options) {
        this.options = options;
        this.defaultFields = utils.clone(fields);
        this.fields = {};
    }

    Search.prototype.TYPE = TYPES;
    Search.prototype.model = model;
    Search.prototype.construct = function() {
        this.fields = utils.addFields.call(this, this.fields);
        

define(function() {
    'use strict';
    var origin = 'api.tomtom.com';
    return {
        'mapboxgl.version': '0.51.0',
        'sdk.version': '4.46.3',
        'analytics.header.name': 'TomTom-User-Agent',
        'analytics.header.sdkName': 'MapsWebSDK',
        'origin': origin,

        // copyrights
        'endpoints.copyrightsWorld': origin + '/map/1/copyrights.{contentType}',
        'endpoints.copyrightsBounds': origin + '/map/1/copyrights/{minLon}/{minLat}/{maxLon}/{maxLat}.{contentType}',
        'endpoints.caption': origin + '/map/1/copyrights/caption.{contentType}',

        // search
        'endpoints.geocode': origin + '/search/2/geocode/{query}.{contentType}',
        'endpoints.batchGeocodeQuery': '/geocode/{query}.{contentType}',
        'endpoints.structuredGeocode': origin + '/search/2/structuredGeocode.{contentType}',
        'endpoints.batchStructuredGeocodeQuery': '/structuredGeocode.{contentType}',
        'endpoints.search': origin + '/search/2/{type}/{query}.{contentType}',
        'endpoints.batchSearch': origin + '/search/2/batch.{contentType}',
        'endpoints.batchSyncSearch': origin + '/search/2/batch/sync.{contentType}',
        'endpoints.batchSearchQuery': '/{type}/{query}.{contentType}',
        'endpoints.adp': origin + '/search/2/additionalData.{contentType}',
        'endpoints.reverseGeocode': origin + '/search/2/{type}/{position}.{contentType}',
        'endpoints.batchReverseGeocodeQuery': '/{type}/{position}.{contentType}',

        // traffic
        'endpoints.trafficIncidents': origin + '/traffic/services/4/incidentDetails/{style}/{minLat},{minLon},{maxLat},{maxLon}/{zoom}/{trafficModelID}/{contentType}',
        'endpoints.trafficViewport': origin + '/traffic/services/4/incidentViewport/0,0,.1,.1/0/0,0,.1,.1/0/false/{contentType}',
        'endpoints.flowSegmentData': origin + '/traffic/services/4/flowSegmentData/{style}/{zoom}/{contentType}',
        'endpoints.incidentRegions': origin + '/traffic/services/4/incidentRegions/{contentType}',

        // layers
        'endpoints.trafficLayer': '{s}.' + origin + '/traffic/map/4/tile/incidents/{style}/{z}/{x}/{y}.png',
        'endpoints.trafficFlowLayer': '{s}.' + origin + '/traffic/map/4/tile/flow/{style}/{z}/{x}/{y}.png',
        'endpoints.tileLayer': '{s}.' + origin + '/map/1/tile/{layer}/{style}/{z}/{x}/{y}.png',

        // routing
        'endpoints.routing': origin + '/routing/1/calculateRoute/{locations}/{contentType}',
        'endpoints.reachableRange': origin + '/routing/1/calculateReachableRange/{origin}/{contentType}',
        'endpoints.batchRouting': origin + '/routing/1/batch/{contentType}',
        'endpoints.batchSyncRouting': origin + '/routing/1/batch/sync/{contentType}',
        'endpoints.batchRoutingQuery': '/calculateRoute/{locations}/{contentType}',
        'endpoints.batchReachableRangeQuery': '/calculateReachableRange/{origin}/{contentType}',
        'endpoints.matrixRouting': origin + '/routing/1/matrix/{contentType}',
        'endpoints.matrixSyncRouting': origin + '/routing/1/matrix/sync/{contentType}',

        //static map image
        'endpoints.staticMapImage': 'https://' + origin + '/map/1/staticimage',

        'vector.glyphs': 'https://' + origin + '/maps-sdk-js/4.46.3/glyphs/{fontstack}/{range}.pbf',
        'vector.sprites': 'https://' + origin + '/maps-sdk-js/4.46.3/sprites/sprite'
    };
});




// WEBPACK FOOTER //
// /home/ubuntu/jenkins/workspace/rp_start_release_npm/jssdk/build/mainConfig.js